// extracted by mini-css-extract-plugin
export default {"tooltip":"GS-z","arrow":"HS-z"};